module.exports = require("./src/crossfilter").crossfilter;
